import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  messageContainer: {
    textAlign: 'right',
  },
}));

export default useStyles;
